import { BehaviorSubject, Subject } from 'rxjs';
import { Quizz, QuizzAnswer, QuizzQuestion } from './quizz.models';

interface QuizzManagerAnswerResponse {
  text: string;
  correct: boolean;
  nextQuestion?: (value?: any) => void;
}

export class QuizzManager {
  private progressionSource = new BehaviorSubject<number>(0);
  progression$ = this.progressionSource.asObservable();

  private currentQuestionSource = new BehaviorSubject<QuizzQuestion>(void 0);
  currentQuestion$ = this.currentQuestionSource.asObservable();

  private answerResponseSource = new Subject<QuizzManagerAnswerResponse>();
  answerResponse$ = this.answerResponseSource.asObservable();

  private currentQuestionIdx = 0;

  get isFirstQuestion(): boolean {
    return this.currentQuestionIdx === 0;
  }

  private get progression(): number {
    return (this.currentQuestionIdx + 1) / this.quizz.questions.length;
  }

  private get currentQuestion(): QuizzQuestion {
    return this.quizz.questions[this.currentQuestionIdx];
  }

  constructor(private quizz: Quizz) {
    this.emit();
  }

  submitAnswer(answer: QuizzAnswer): void {
    if (!this.currentQuestion.selectedValue) {
      this.currentQuestion.selectedValue = answer.value;

      let nextQuestion = void 0;
      if (this.currentQuestionIdx < this.quizz.questions.length - 1) {
        new Promise<any>(r => (nextQuestion = r)).then(() => {
          this.currentQuestionIdx++;
          this.emit();
        });
      }

      if (answer.value === this.currentQuestion.correctValue) {
        answer.displayAsRight = true;
        this.answerResponseSource.next({
          text: this.currentQuestion.rightAnswerText,
          correct: true,
          nextQuestion
        });
      } else {
        answer.displayAsWrong = true;
        this.answerResponseSource.next({
          text: this.currentQuestion.wrongAnswerText,
          correct: false,
          nextQuestion
        });
      }
    }
  }

  forgeDataForMOBI(): any {
    return this.quizz.questions.reduce(
      (acc, cur) => ({ ...acc, [cur.name]: cur.selectedValue }),
      {}
    );
  }

  private emit(): void {
    this.progressionSource.next(this.progression);
    this.currentQuestionSource.next(this.currentQuestion);
  }
}
